(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx-state-tree"), require("underscore"), require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"), require("mobx"), require("polyglot"), require("explore-common"), require("gemini/lib/@waca/core-client/js/core-client/ui/core/Class"), require("dashboard-analytics/visualizations/vipr/VIPRConfig"), require("gemini/lib/@waca/core-client/js/core-client/utils/UniqueId"));
	else if(typeof define === 'function' && define.amd)
		define(["mobx-state-tree", "underscore", "@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons", "mobx", "polyglot", "explore-common", "gemini/lib/@waca/core-client/js/core-client/ui/core/Class", "dashboard-analytics/visualizations/vipr/VIPRConfig", "gemini/lib/@waca/core-client/js/core-client/utils/UniqueId"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("mobx-state-tree"), require("underscore"), require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"), require("mobx"), require("polyglot"), require("explore-common"), require("gemini/lib/@waca/core-client/js/core-client/ui/core/Class"), require("dashboard-analytics/visualizations/vipr/VIPRConfig"), require("gemini/lib/@waca/core-client/js/core-client/utils/UniqueId")) : factory(root["mobx-state-tree"], root["underscore"], root["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"], root["mobx"], root["polyglot"], root["explore-common"], root["gemini/lib/@waca/core-client/js/core-client/ui/core/Class"], root["dashboard-analytics/visualizations/vipr/VIPRConfig"], root["gemini/lib/@waca/core-client/js/core-client/utils/UniqueId"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_31__, __WEBPACK_EXTERNAL_MODULE_37__, __WEBPACK_EXTERNAL_MODULE_41__, __WEBPACK_EXTERNAL_MODULE_460__) {
return webpackJsonp([3],{

/***/ 11:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isExplore = undefined;

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isExplore(selection) {
	if (selection) {
		var foundInvalid = selection.some(function (item) {
			// The item must be an explore type.
			if ((item.tags || []).indexOf('explore') === -1) {
				return true;
			}

			// The item must be either module or uploaded File
			if (['exploration', 'page_asset'].indexOf(item.type) === -1) {
				return true;
			}

			// The item must have read permission
			var aPerm = ['read', 'execute'];
			if (_underscore2.default.intersection(item.permissions, aPerm).length < aPerm.length) {
				return true;
			}

			// The item must not be disabled
			if (item.disabled && item.disabled.toString().toLowerCase() === 'true') {
				return true;
			}

			return false;
		});

		return !foundInvalid;
	}
	return false;
} /*
   *+------------------------------------------------------------------------+
   *| Licensed Materials - Property of IBM
   *| IBM Cognos Products: Explore
   *| (C) Copyright IBM Corp. 2018
   *|
   *| US Government Users Restricted Rights - Use, duplication or disclosure
   *| restricted by GSA ADP Schedule Contract with IBM Corp.
   *+------------------------------------------------------------------------+
   */

exports.isExplore = isExplore;

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_31__;

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_37__;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_41__;

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30);
module.exports = __webpack_require__(458);


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ShareActionHandler = exports.OpenActionHandler = exports.NewActionHandler = undefined;

var _NewActionHandler = __webpack_require__(459);

var _NewActionHandler2 = _interopRequireDefault(_NewActionHandler);

var _OpenActionHandler = __webpack_require__(461);

var _OpenActionHandler2 = _interopRequireDefault(_OpenActionHandler);

var _ShareActionHandler = __webpack_require__(462);

var _ShareActionHandler2 = _interopRequireDefault(_ShareActionHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NewActionHandler = _NewActionHandler2.default;
exports.OpenActionHandler = _OpenActionHandler2.default;
exports.ShareActionHandler = _ShareActionHandler2.default; /*
                                                            *+------------------------------------------------------------------------+
                                                            *| Licensed Materials - Property of IBM
                                                            *| IBM Cognos Products: Explore
                                                            *| (C) Copyright IBM Corp. 2018
                                                            *|
                                                            *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                            *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                            *+------------------------------------------------------------------------+
                                                            */

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _CapabilityUtil = __webpack_require__(46);

var _StringResources = __webpack_require__(1);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var BaseClass = __webpack_require__(37);
var _ = __webpack_require__(8);
var UniqueId = __webpack_require__(460);

var ActionHandler = BaseClass.extend({
	/**
  * Determine if we can execute the action based on the selection
  */
	canExecute: function canExecute(options) {
		return this._isSelectionValid(options) && (0, _CapabilityUtil.hasCapability)(options.glassContext);
	},

	/**
  * Determine when we show/hide the menu item
  */
	isItemVisible: function isItemVisible(options) {
		return this.canExecute(options);
	},

	/**
  * Default action handler
  */
	doAction: function doAction(context) {
		// Make a 'created' call to the instrumentation service when we create a new explore
		this._instrumentationTrack(context);
		return this._openCreateView(context);
	},

	_instrumentationTrack: function _instrumentationTrack(context) {
		var instrumentation = context.glassContext.getCoreSvc('.Instrumentation');
		if (instrumentation.enabled) {
			var objectType = 'explore';
			var action = 'created';
			var basePayload = {
				type: 'Created Object',
				objectType: objectType,
				action: action,
				milestoneName: action + '_' + objectType
			};
			var dataSourcesInfo = {};
			// If new explore is created from an existing datasource
			if (context.options) {
				dataSourcesInfo = this._getDatasourcesInfo(context.options);
			}
			instrumentation.track(_extends({}, basePayload, dataSourcesInfo));
		}
	},

	_getDatasourcesInfo: function _getDatasourcesInfo(dataSources) {
		var dataSourceInfoMap = {
			uploadedFile: 'custom.counts.uploadedFile',
			module: 'custom.counts.Module',
			package: 'custom.counts.fmPackage'
		};
		var dataSourcesInfo = {};
		dataSources.forEach(function (_ref) {
			var type = _ref.type;

			if (!dataSourcesInfo[dataSourceInfoMap[type]]) {
				dataSourcesInfo[dataSourceInfoMap[type]] = 0;
			}
			dataSourcesInfo[dataSourceInfoMap[type]] = dataSourcesInfo[dataSourceInfoMap[type]] + 1;
		});
		return dataSourcesInfo;
	},

	/**
  * Menu item handler
  */
	onSelectItem: function onSelectItem(context) {
		this.doAction(context);
	},

	// Private
	_getRestrictTemplate: function _getRestrictTemplate() /*context*/{
		return 'explore';
	},

	// Private
	_openCreateView: function _openCreateView(context) {
		var template = this._getRestrictTemplate();
		var sPerspectiveID = UniqueId.get('explore_');
		var perspectiveOptions = {
			id: sPerspectiveID,
			content: {
				id: sPerspectiveID,
				restrictTemplate: template,
				boardSpec: null,
				isAuthoringMode: true
			}
		};
		var sources = this._getSources(context);
		if (sources && sources.length > 0) {
			perspectiveOptions.content.sources = sources;
			perspectiveOptions.content.boardSpec = this._createEmptyBoardSpec();
			return context.glassContext.appController.openAppView('explore', perspectiveOptions).then(function (view) {
				return !view.currentContentView.isFeatureEnabled('newStartingPoints', 'false') ? view.currentContentView.openCardListPane() : view.currentContentView.openDatasetpane();
			});
		}

		this._openDataSourceDialog(context, perspectiveOptions);
	},

	// Private function that opens the data source dialog
	_openDataSourceDialog: function _openDataSourceDialog(context, perspectiveOptions) {
		var supportedTypes = ['module', 'dataSet2', 'uploadedFile', 'package', 'data_asset'];
		var options = {
			'glassContext': context.glassContext,
			'typesToOpen': supportedTypes,
			'multiSelect': false,
			'dialogTitle': _StringResources2.default.get('addDatasourceToExploreDialogTitle'),
			'primaryBtnText': _StringResources2.default.get('addDataSourceDialogButtonLabel'),
			'onOpenCallback': this._onAddDataSource.bind(this, context, perspectiveOptions)
		};
		return context.glassContext.getSvc('.ContentDialogFactory').then(function (dialogFactory) {
			dialogFactory.createOpenDialog(options).open();
		});
	},

	// Private function which launches explore when data source has been selected from the data source dialog
	_onAddDataSource: function _onAddDataSource(context, perspectiveOptions, selectedItems) {
		// There is only 1 selected data source in this function because multiSelect is set to false in onAddBtnClick
		var selectedItem = selectedItems[0];
		var dataSource = {
			'assetId': selectedItem.id,
			'name': selectedItem.defaultName,
			'type': selectedItem.type,
			'searchPath': selectedItem.searchPath,
			'isOlapPackage': selectedItem.userInterfaces && selectedItem.userInterfaces.indexOf('analysisStudio') >= 0,
			'modificationTime': selectedItem.modificationTime
		};
		perspectiveOptions.content.sources = [dataSource];
		perspectiveOptions.content.boardSpec = this._createEmptyBoardSpec();
		return context.glassContext.appController.openAppView('explore', perspectiveOptions).then(function (view) {
			return !view.currentContentView.isFeatureEnabled('newStartingPoints', 'false') ? view.currentContentView.openCardListPane() : view.currentContentView.openDatasetpane();
		});
	},

	//TODO:This function should be a common function for both dashboard and explore 'new' action handlers
	_getSources: function _getSources(options) {
		var isSelectionValid = this._isSelectionValid(options, false);
		var dataSourcesArray = null;
		if (isSelectionValid) {
			dataSourcesArray = [];
			if (!options.target.activeObject) {
				return dataSourcesArray;
			}
			var selections = options.target.activeObject.aSelectedContext;
			for (var _iterator = selections, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
				var _ref2;

				if (_isArray) {
					if (_i >= _iterator.length) break;
					_ref2 = _iterator[_i++];
				} else {
					_i = _iterator.next();
					if (_i.done) break;
					_ref2 = _i.value;
				}

				var oSelection = _ref2;

				dataSourcesArray.push({
					assetId: oSelection.id,
					type: oSelection.type,
					name: oSelection.defaultName,
					searchPath: oSelection.searchPath,
					isOlapPackage: oSelection.userInterfaces && _.indexOf(oSelection.userInterfaces, 'analysisStudio') >= 0
				});
			}
		}
		return dataSourcesArray;
	},

	//TODO:This function should be a common function for both dashboard and explore 'new' action handlers
	_isSelectionValid: function _isSelectionValid(options) {
		var selection = options.target && options.target.activeObject && options.target.activeObject.aSelectedContext;
		var supportedTypes = ['module', 'dataSet2', 'uploadedFile', 'package', 'data_asset'];
		if (selection && Array.isArray(selection)) {
			for (var _iterator2 = selection, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
				var _ref3;

				if (_isArray2) {
					if (_i2 >= _iterator2.length) break;
					_ref3 = _iterator2[_i2++];
				} else {
					_i2 = _iterator2.next();
					if (_i2.done) break;
					_ref3 = _i2.value;
				}

				var item = _ref3;

				// The item must be either module or uploaded File
				var aType = supportedTypes;
				if (_.intersection([item.type], aType).length < 1) {
					return false;
				}
				// The item must have read permission
				var aPerm = ['read'];
				if (_.intersection(item.permissions, aPerm).length < aPerm.length) {
					return false;
				}
				// The item must not be disabled
				if (item.disabled && item.disabled.toString().toLowerCase() === 'true') {
					return false;
				}
			}
		}
		return true;
	},

	_createEmptyBoardSpec: function _createEmptyBoardSpec() {
		var spec = {
			name: _StringResources2.default.get('defaultName'),
			layout: {
				type: 'exploreContainer',
				items: []
			},
			widgets: {},
			_meta: {
				bundleID: null
			}
		};
		return spec;
	}
});

exports.default = ActionHandler;

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_460__;

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _CapabilityUtil = __webpack_require__(46);

var _AssetUtil = __webpack_require__(112);

var _ExploreViewModel = __webpack_require__(35);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var OpenActionHandler = function () {
	function OpenActionHandler() {
		_classCallCheck(this, OpenActionHandler);
	}

	OpenActionHandler.prototype.canExecute = function canExecute(options) {
		var selection = options.target && options.target.activeObject && options.target.activeObject.aSelectedContext;

		return (0, _AssetUtil.isExplore)(selection) && (0, _CapabilityUtil.hasCapability)(options.glassContext);
	};

	OpenActionHandler.prototype.isItemVisible = function isItemVisible(options) {
		return this.canExecute(options);
	};

	OpenActionHandler.prototype.doAction = function doAction(options) {
		var id = options.target.activeObject.aSelectedContext[0].id;

		// Make an 'edited' call to the instrumentation service when we open an existing explore
		this._instrumentationTrack(id, options.glassContext);

		return this.openExplore(options.glassContext.appController, id);
	};

	OpenActionHandler.prototype._instrumentationTrack = function _instrumentationTrack(id, glassContext) {
		var instrumentation = glassContext.getCoreSvc('.Instrumentation');
		if (instrumentation.enabled) {
			var objectType = 'explore';
			var action = 'edited';
			var payload = {
				type: 'Read Object',
				objectType: objectType,
				object: id,
				action: action,
				milestoneName: action + '_' + objectType
			};
			instrumentation.track(payload);
		}
	};

	OpenActionHandler.prototype.onSelectItem = function onSelectItem(options) {
		return this.doAction(options);
	};

	// Private

	OpenActionHandler.prototype.openExplore = function openExplore(appController, id) {
		return appController.openAppView('explore', {
			id: id,
			content: {
				boardId: id,
				isAuthoringMode: true,
				// build a complete urlMap context for dashboard/story
				objRef: id
			}
		}).then(function (view) {
			var displayedCard = view.currentContentView.boardModel.layout.exploreVM.displayedCard;
			var isNewStartingPoints = !view.currentContentView.isFeatureEnabled('newStartingPoints', 'false');
			return displayedCard && displayedCard === _ExploreViewModel.STARTING_POINTS && isNewStartingPoints === false ? view.currentContentView.openDatasetpane() : view.currentContentView.openCardListPane();
		});
	};

	return OpenActionHandler;
}();

exports.default = OpenActionHandler;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AssetUtil = __webpack_require__(112);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var VIDA_MAP_ANIM_TIMEOUT_MILLIS = 10000; //10 seconds

var DOM_CLASSES_MAP = {
	relationship: '.relationshipViewWrapper:visible',
	card: '.explore-content:visible'
};

var ShareActionHandler = function () {

	/**
  * @param {options} set of initial properties
  */
	function ShareActionHandler(options) {
		_classCallCheck(this, ShareActionHandler);

		this.vidaMapAnimTimeout = options && options.vidaMapAnimTimeout || VIDA_MAP_ANIM_TIMEOUT_MILLIS;
	}

	ShareActionHandler.prototype.execute = function execute(context) {
		if (context.urlMap.objRef) {
			var share = {
				perspective: 'explore',
				objRef: context.urlMap.objRef
			};
			var view = context.glassContext.appController.getCurrentContentView();
			if (view.perspective === 'explore' && typeof view.boardController.layoutController.getCurrentSubViewId === 'function') {
				share.subView = view.boardController.layoutController.getCurrentSubViewId();
			}
			return share;
		} else {
			throw new Error('Unable to resolve share context. Missing objRef.');
		}
	};

	ShareActionHandler.prototype.getShareableItems = function getShareableItems(context) {
		var _this = this;

		var items = [];
		var view = context.glassContext.appController.getCurrentContentView();
		var captureReadyPromise = Promise.resolve();
		if (view.perspective === 'explore') {
			var exploreApi = view.getExploreApi();
			captureReadyPromise = this._waitForViewLoaded(exploreApi).then(function () {
				var $content = _this._getCapturedElement(view, exploreApi);
				items.push({
					el: $content.length === 1 ? $content.get(0) : view.$el.get(0) /* should never get here but just in case... */
					, label: view.getTitle()
				});
			});
		}

		return captureReadyPromise.then(function () {
			return _this.reRenderMaps(view);
		}).then(function () {
			return Promise.resolve(items);
		});
	};

	ShareActionHandler.prototype._waitForViewLoaded = function _waitForViewLoaded(exploreApi) {
		return exploreApi.isStartingPointsDisplayed() ? exploreApi.getStartingPointsAPI().whenRelationshipDataReady() : Promise.resolve();
	};

	ShareActionHandler.prototype._getCapturedElement = function _getCapturedElement(view, exploreApi) {
		var className = exploreApi.isStartingPointsDisplayed() ? 'relationship' : 'card';
		return view.$el.find(DOM_CLASSES_MAP[className]);
	};

	/**
  * Re-render map widgets for screen capture. Allow sub-classes to access.
  * @protected
  * @param {Object} view Content View object of the explore perspective
  * @return {Promise}
  */


	ShareActionHandler.prototype.reRenderMaps = function reRenderMaps(view) {
		var TILEDMAP = 'com.ibm.vis.rave2bundletiledmap';
		if (!view.boardController || !view.boardController.layoutController) {
			return Promise.resolve();
		}
		var layoutController = view.boardController.layoutController;
		var selectedWidgets = layoutController.getSelectedWidgets();
		var promises = [];
		if (selectedWidgets && selectedWidgets.length > 0) {
			promises = selectedWidgets.map(function (widget) {
				//Rerender Map only
				if (layoutController.getLayoutWidgetModel(widget.id).visId === TILEDMAP) {
					var canvas = layoutController.dashboardApi.getCanvas();
					var widgetApi = canvas.getWidget(widget.id);
					var visApi = widgetApi.getVisApi();
					return visApi.mapVizRenderForPrint();
				}
			}).filter(function (entry) {
				return entry !== undefined;
			});
		}
		if (promises.length > 0) {
			var delay = function delay(time) {
				return function (result) {
					return new Promise(function (resolve) {
						setTimeout(function () {
							return resolve(result);
						}, time);
					});
				};
			};
			return Promise.all(promises).then(delay(this.vidaMapAnimTimeout)); //Timeout is needed for the VIDA map animation.
		} else {
			return Promise.resolve({});
		}
	};

	ShareActionHandler.prototype.isEnabled = function isEnabled(context) {
		return this.isExplore(context);
	};

	ShareActionHandler.prototype.isExplore = function isExplore() {
		var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    _ref$glassContext = _ref.glassContext,
		    glassContext = _ref$glassContext === undefined ? {} : _ref$glassContext,
		    context = _ref.context;

		var _glassContext$appCont = glassContext.appController;
		_glassContext$appCont = _glassContext$appCont === undefined ? {} : _glassContext$appCont;
		var _glassContext$appCont2 = _glassContext$appCont.currentAppView;
		_glassContext$appCont2 = _glassContext$appCont2 === undefined ? {} : _glassContext$appCont2;
		var perspective = _glassContext$appCont2.perspective;


		return perspective === 'explore' || (0, _AssetUtil.isExplore)(context);
	};

	ShareActionHandler.prototype.getInstrumentation = function getInstrumentation(context) {
		return context.glassContext.appController.getCurrentContentView().getDashboardApi().getFeature('segment').getInfo({ type: 'Shared Object' });
	};

	return ShareActionHandler;
}();

exports.default = ShareActionHandler;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ })

},[457]);
});


// WEBPACK FOOTER //
// action-handlers.min.js